import Image from "ui-components/Image";
import classNames from "classnames";
import { NavLink } from "react-router-dom";
import { isTestnet, projectName } from "utils/configs";
import { useTeleSwap } from "services/useTeleSwap";
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";

export default function PromotionBanner() {
    const [show, setShow] = useState(true);
    const { getBanners } = useTeleSwap();
    const { data: banners } = useQuery({
        queryKey: [`getBanners`],
        queryFn: () => {
            return getBanners();
        },
        refetchOnWindowFocus: false,
        refetchInterval: false,
        retry: false,
    });
    if (!banners || !banners.length) return null;

    return show ? (
        <div className={classNames(" bg-[#f3ffeb]   flex justify-center items-center  px-4 w-full  h-auto")}>
            <div className="flex items-center w-full justify-center p-3 gap-2">
                <Image src="/images/magic-fill.svg" title="magic" />
                <div className="flex font-medium items-center text-sm"> {banners[0]?.title}</div>
                {banners[0]?.link && banners[0]?.link !== "" && (
                    <NavLink
                        className="flex min-w-[75px] items-center text-sm underline hover:font-bold text-black "
                        target={banners[0]?.link === "" ? "_self" : "_blank"}
                        to={banners[0]?.link}
                    >
                        Click Here
                    </NavLink>
                )}
                <span className="text-sm font-medium absolute right-[10px]">
                    <Image
                        src="/images/close-line.svg"
                        title="Close"
                        onClick={() => setShow(false)}
                        className="cursor-pointer"
                    />
                </span>
            </div>
        </div>
    ) : null;
}
